import { Fade, Typography } from "@mui/material";
import type { FC } from "react";
import { COLORS } from "../types";

const ANIMATION_STAGGER_MS = 100;

interface SimulationNameCellProps {
	name: string;
	isNewHire: boolean;
	delay: number;
	animate: boolean;
}

export const SimulationNameCell: FC<SimulationNameCellProps> = ({ name, isNewHire, delay, animate }) => {
	const content = (
		<Typography
			sx={{
				fontSize: "10px",
				fontWeight: 600,
				color: isNewHire ? COLORS.primary : COLORS.success,
				lineHeight: 1.4,
			}}
		>
			{name}
		</Typography>
	);

	if (!animate) return content;

	return (
		<Fade in timeout={200} style={{ transitionDelay: `${delay}ms` }}>
			{content}
		</Fade>
	);
};

export { ANIMATION_STAGGER_MS };
